// src/services/api.js
import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API cho Stations
export const stationAPI = {
  getAll: async () => {
    const response = await apiClient.get('/api/stations');
    return response.data;
  },
  
  search: async (searchText) => {
    const response = await apiClient.get('/api/stations/search', {
      params: { searchText }
    });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await apiClient.get(`/api/stations/${id}`);
    return response.data;
  },
  
  create: async (stationData) => {
    const response = await apiClient.post('/api/stations', stationData);
    return response.data;
  },
  
  update: async (id, stationData) => {
    const response = await apiClient.put(`/api/stations/${id}`, stationData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/api/stations/${id}`);
    return response.data;
  },
};

// API cho Routes
export const routeAPI = {
  getAll: async () => {
    const response = await apiClient.get('/api/routes');
    return response.data;
  },

  search: async (searchText) => {
    const response = await apiClient.get('/api/routes/search', {
      params: { searchText }
    });
    return response.data;
  },

  getRealPaths: async () => {
    const response = await apiClient.get('/api/routes/real-paths');
    return response.data;
  },

  getRealPathById: async (id) => {
    const response = await apiClient.get(`/api/routes/${id}/real-path`);
    return response.data;
  },

  getRealPathFromCoordinates: async (coordinates) => {
    const response = await apiClient.post('/api/routes/real-path-from-coordinates', {
      coordinates
    });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await apiClient.get(`/api/routes/${id}`);
    return response.data;
  },
  
  create: async (routeData) => {
    const response = await apiClient.post('/api/routes', routeData);
    return response.data;
  },
  
  update: async (id, routeData) => {
    const response = await apiClient.put(`/api/routes/${id}`, routeData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/api/routes/${id}`);
    return response.data;
  },
};

// API cho Pathfinding
export const pathfindingAPI = {
  findRoute: async (startLat, startLon, endLat, endLon, maxDistance = 1000) => {
    const response = await apiClient.post('/api/pathfinding/find-route', {
      startLat,
      startLon,
      endLat,
      endLon,
      maxDistance
    });
    return response.data;
  },

  findNearestStation: async (lat, lon, maxDistance = 1000) => {
    const response = await apiClient.get('/api/pathfinding/nearest-station', {
      params: { lat, lon, maxDistance }
    });
    return response.data;
  },

  findRoutesByStation: async (stationId) => {
    const response = await apiClient.get(`/api/pathfinding/routes-by-station/${stationId}`);
    return response.data;
  },
};

// API cho Authentication
export const authAPI = {
  register: async (userData) => {
    const response = await apiClient.post('/api/auth/register', userData);
    return response.data;
  },

  login: async (credentials) => {
    const response = await apiClient.post('/api/auth/login', credentials);
    return response.data;
  },

  getMe: async () => {
    const token = localStorage.getItem('token');
    const response = await apiClient.get('/api/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};

// API cho Payment
export const paymentAPI = {
  createPaymentUrl: async (amount, orderDescription = 'Thanh toan ve xe buyt', routeIds = []) => {
    const response = await apiClient.post('/api/payment/create_payment_url', {
      amount,
      orderDescription,
      routeIds,
      orderType: 'billpayment',
      language: 'vn'
    });
    return response.data;
  },
};

export const revenueAPI = {
  getRevenueReport: async (month, year) => {
    const response = await apiClient.get('/api/revenue/report', {
      params: { month, year }
    });
    return response.data;
  },
};

// Interceptor để tự động thêm token vào headers
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor để handle 401 errors (token hết hạn)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
